import { render, staticRenderFns } from "./TabelaBuscaNcm.vue?vue&type=template&id=6cc887dd&scoped=true&"
import script from "./TabelaBuscaNcm.vue?vue&type=script&lang=js&"
export * from "./TabelaBuscaNcm.vue?vue&type=script&lang=js&"
import style0 from "./TabelaBuscaNcm.vue?vue&type=style&index=0&id=6cc887dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc887dd",
  null
  
)

export default component.exports